<template>
  <CContainer>
    <TheAsideBar :componentName="$attrs.AsidebarComponente"/>
    <CWrapper class="justify-content-between">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </CWrapper>
  </CContainer>
</template>

<script>
import TheAsideBar from "./TheAsideBar";

export default {
  name: "TheMainSidebar",
  components: {
    TheAsideBar,
  }
};
</script>

<style>
</style>
